import 'sass/blocks/_legal-info.scss';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import initialActions from 'actions/initialActions';
import preLoaderActions from 'actions/preLoaderActions';
import CustomScrollBar from 'components/customScrollBar/customScrollBar';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { CREDIT_CARD } from 'constants/userProfile';
import { useFileDownload } from './hooks/useFileDownload';
import { useProducts } from './hooks/useProducts';
import { Documentation } from './Documentation/Documentation';
import { Header } from './Header/Header';
import { DocumentActions } from './DocumentActions/DocumentActions';
import { Logo } from './Logo/Logo';

const LegalInfoComponent = ({
    initialActions,
    initialStep,
    preLoaderActions,
    products,
    userProfile: { investmentType },
}) => {
    const { handleOnStartFileDownload } = useFileDownload({
        initialStep,
        showPreLoader: preLoaderActions.showPreLoader,
        hidePreLoader: preLoaderActions.hidePreLoader,
        clearPdf: initialActions.clearPdf,
        getPdfMerge: initialActions.getPdfMerge,
        pdfDownloadLink: initialStep.get('pdfDownloadLink'),
        pdfDownloadLinkName: initialStep.get('pdfDownloadLinkName'),
    });

    const { precontractualLinks, productsInfo, getPartnerId } = useProducts({ products, investmentType });

    const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);

    return (
        <div>
            <Header />
            <div className="legal-info__doc-block">
                <div className="row">
                    <Logo />
                    <DocumentActions
                        handleOnStartFileDownload={handleOnStartFileDownload}
                        isCreditCard={userInvestmentType[CREDIT_CARD]}
                        precontractualLinks={precontractualLinks}
                        productsInfo={productsInfo}
                    />
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <CustomScrollBar width="100%" autoHeightMin={195}>
                            <Documentation
                                getPartnerId={getPartnerId}
                                isCreditCard={userInvestmentType[CREDIT_CARD]}
                                productsInfo={productsInfo}
                            />
                        </CustomScrollBar>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const LegalInfo = connect(
    state => ({
        userProfile: state.userProfile,
        preLoader: state.preLoader,
        initialStep: state.initialStep,
        products: state.products,
    }),
    dispatch => ({
        initialActions: bindActionCreators(initialActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(LegalInfoComponent);
